//src/components/UserSidebar.js
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  ShoppingCart,
  Wallet,
  Ticket,
  Settings,
  Layers,
  BookText,
  ListChecks,
} from "lucide-react";

export default function UserSidebar() {
  const location = useLocation();

  const linkBase =
    "flex items-center gap-3 px-4 py-2 rounded-xl text-sm font-medium transition";
  const linkActive =
    "bg-purple-600/70 shadow-lg text-white";
  const linkInactive =
    "text-gray-300 hover:bg-white/10";

  const navClass = (active) =>
    `${linkBase} ${active ? linkActive : linkInactive}`;

  return (
    <aside className="w-64 h-screen bg-[#0d111b]/60 backdrop-blur-xl border-r border-white/10 shadow-xl text-white fixed left-0 top-0 p-6 flex flex-col">
      
      {/* LOGO */}
      <div className="flex items-center gap-3 mb-8">
        <img
          src="/logo.png"
          alt="SMSOrbit"
          className="w-10 h-10 rounded-xl"
        />
        <div className="flex flex-col leading-tight">
          <span className="text-sm font-semibold tracking-wide">
            SMSOrbit
          </span>
          <span className="text-[11px] text-slate-400">
            User Panel
          </span>
        </div>
      </div>

      {/* NAVIGATION */}
      <nav className="space-y-2 flex-1">
        <NavLink to="/dashboard" className={({ isActive }) => navClass(isActive)}>
          <LayoutDashboard size={18} />
          Dashboard
        </NavLink>

        <NavLink to="/new-order" className={({ isActive }) => navClass(isActive)}>
          <ShoppingCart size={18} />
          New Order
        </NavLink>

        <NavLink to="/orders" className={({ isActive }) => navClass(isActive)}>
          <ListChecks size={18} />
          Order History
        </NavLink>

        {/* ✅ WALLET (END = exact match only) */}
        <NavLink
          to="/wallet"
          end
          className={({ isActive }) => navClass(isActive)}
        >
          <Wallet size={18} />
          Wallet
        </NavLink>

        {/* ✅ WALLET HISTORY (manual match) */}
        <NavLink
          to="/wallet/history"
          className={() =>
            navClass(location.pathname === "/wallet/history")
          }
        >
          <BookText size={18} />
          Wallet History
        </NavLink>

        <NavLink to="/tickets" className={({ isActive }) => navClass(isActive)}>
          <Ticket size={18} />
          Support Tickets
        </NavLink>

        <NavLink to="/api-keys" className={({ isActive }) => navClass(isActive)}>
          <BookText size={18} />
          API Access
        </NavLink>

        <NavLink to="/mass-order" className={({ isActive }) => navClass(isActive)}>
          <Layers size={18} />
          Mass Order
        </NavLink>

        <NavLink
          to="/user/services"
          className={({ isActive }) => navClass(isActive)}
        >
          <Layers size={18} />
          Services
        </NavLink>

        <NavLink to="/settings" className={({ isActive }) => navClass(isActive)}>
          <Settings size={18} />
          Settings
        </NavLink>
      </nav>
    </aside>
  );
}
